'use client';

import { Loader } from '@/components/loader';
import { redirectService } from '@/lib/redirect';
import { useAuthStore } from '@/store';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const RedirectIfAuthenticated = ({
  children,
  redirectTo = redirectService.getRedirect('/home'),
}: {
  children: React.ReactNode;
  redirectTo?: string;
}) => {
  const token = useAuthStore((state) => state.token);
  const user = useAuthStore((state) => state.user);
  const isHydrated = useAuthStore((state) => state.isHydrated);

  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const to = searchParams.get('redirectTo') || redirectTo;

  const isProfileComplete = Boolean(user?.userName);

  useEffect(() => {
    if (!isHydrated) return;

    // Logged in + profile NOT completed → force setup
    if (token && !isProfileComplete && pathname !== '/profile-setup') {
      router.replace('/profile-setup');
      return;
    }

    // Logged in + profile completed + visiting auth pages → redirect away
    if (token && isProfileComplete) {
      router.replace(to);
    }
  }, [token, isProfileComplete, pathname, isHydrated, router, to]);

  // Block render while resolving state
  if (!isHydrated) {
    return <Loader />;
  }

  // While redirecting logged-in users
  if (token) {
    return <Loader />;
  }

  // Not logged in → allow access
  return <>{children}</>;
};
